import styled from 'styled-components'
import { Modal } from '../modal'
import { Flex } from '../flex'
import { Typography } from '../typography'
import { TranslationProps } from './documents-gallery.types'
import { useState } from 'react'
import { GalleryThumbnails } from './gallery-thumbnails'
import { Icon } from '../icon'

const TranslationContainer = styled(Flex)`
  ${({ theme }) => `
    white-space: pre-line;
    background-color: ${theme.colors.white};
    border-radius: ${theme.sizes.xs};
    border: 1px solid ${theme.colors.gray90};
    overflow-y: auto;
    max-height: 85vh;
    min-height: 200px;
`}
`

const GalleryContainer = styled(Flex)`
  ${({ theme }) => `
    background-color: ${theme.colors.gray80};
  `}
`

const ThumbnailContainer = styled(Flex)`
  > div {
    margin-bottom: 0;
  }
`

const CloseButton = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  flex-grow: 1;
  padding: 4px;
  cursor: pointer;
`

export const Translation = ({
  onClose,
  files,
  url,
  translationContentTitle,
}: TranslationProps) => {
  const [selectedFileUrl, setSelectedFileUrl] = useState(url)

  const translation = files.find(
    (file) => file.url === selectedFileUrl
  )?.translation

  const filesWithTranslation = files.filter((file) => file.translation)

  return (
    <Modal open onClose={onClose} overflowHidden width={900}>
      <GalleryContainer direction="column" gap={8} p={8}>
        <ThumbnailContainer>
          {filesWithTranslation.length > 1 && (
            <GalleryThumbnails
              files={filesWithTranslation}
              selectedFileUrl={selectedFileUrl}
              onThumbnailClick={setSelectedFileUrl}
            />
          )}
          <CloseButton onClick={onClose}>
            <Icon name="close" size={4} color="gray600" />
          </CloseButton>
        </ThumbnailContainer>
        <TranslationContainer direction="column" gap={8} p={16}>
          {translationContentTitle && (
            <Typography variant="h5">{translationContentTitle}</Typography>
          )}
          <Typography variant="large">{translation}</Typography>
        </TranslationContainer>
      </GalleryContainer>
    </Modal>
  )
}
